module.exports = __webpack_public_path__ + "static/img/b2.4cc7cb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b2.png
// module id = TGLZ
// module chunks = 1